import {renderElement} from '@Utils/root-element.util';
import {Provider} from 'react-redux';
import type {MergeTagsProps} from '@Components/merge-tags/merge-tags.types';
import MergeTags from '@Components/merge-tags/merge-tags';
import {MergeTagsDropdown} from '@Components/merge-tags/merge-tags-dropdown/merge-tags-dropdown';
import type {EmailMakerColorPickerDropdownProps} from '@Components/email-maker-color-picker-dropdown/email-maker-color-picker-dropdown';
import {EmailMakerColorPickerDropdown} from '@Components/email-maker-color-picker-dropdown/email-maker-color-picker-dropdown';
import type {MergeTagsDropdownProps} from '@Components/merge-tags/merge-tags-dropdown/merge-tags-dropdown.types';
import type {EmailMakerSocialLinkInputSuggestionsProps} from '@Components/email-maker-social-link-suggestions-dropdown/email-maker-social-link-suggestions-dropdown.types';
import {EmailMakerSocialLinkSuggestionsDropdown} from '@Components/email-maker-social-link-suggestions-dropdown/email-maker-social-link-suggestions-dropdown';
import type {EmailMakerAiRewritePromptBoxDropdownProps} from '@Components/email-maker-ai-rewrite-prompt-box-dropdown/email-maker-ai-rewrite-prompt-box-dropdown';
import {EmailMakerAiRewritePromptBoxDropdown} from '@Components/email-maker-ai-rewrite-prompt-box-dropdown/email-maker-ai-rewrite-prompt-box-dropdown';
import {AddBlockMenu} from '@Components/email-maker-block-manager/components/add-block-menu/add-block-menu';
import type {AddBlockMenuProps} from '@Components/email-maker-block-manager/components/add-block-menu/add-block-menu.types';
import {GrapesjsEditorContext} from '@Components/email-maker-block-manager/email-maker-block-manager-grapesjs-editor-context';
import type {Editor} from 'grapesjs';

window.PMW.mergePMW(window.PMW, {
  initMergeTagsStyles(contentContainer: HTMLElement, mergeTagsProps: MergeTagsProps) {
    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <MergeTags {...mergeTagsProps} />
      </Provider>
    );
  },

  initMergeTagsDropDown(contentContainer: HTMLElement, opts: MergeTagsDropdownProps) {
    if (!contentContainer) {
      return;
    }

    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <MergeTagsDropdown key={opts.listId} {...opts} />
      </Provider>
    );
  },

  renderColorPickerDropdownForText(contentContainer: HTMLElement, opts: EmailMakerColorPickerDropdownProps) {
    if (!contentContainer) {
      return;
    }

    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerColorPickerDropdown {...opts} />
      </Provider>
    );
  },

  initSocialLinksSuggestionsDropdown(contentContainer: HTMLElement, opts: EmailMakerSocialLinkInputSuggestionsProps) {
    if (!contentContainer) {
      return;
    }

    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerSocialLinkSuggestionsDropdown {...opts} />
      </Provider>
    );
  },

  renderAiRewritePromptBoxDropdown(contentContainer: HTMLElement, opts: EmailMakerAiRewritePromptBoxDropdownProps) {
    if (!contentContainer) {
      return;
    }
    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerAiRewritePromptBoxDropdown {...opts} />
      </Provider>
    );
  },

  renderAddElementMenu(contentContainer: HTMLElement, opts: AddBlockMenuProps, editor: Editor) {
    if (!contentContainer) {
      return;
    }
    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <GrapesjsEditorContext.Provider value={editor}>
          <AddBlockMenu {...opts} />
        </GrapesjsEditorContext.Provider>
      </Provider>
    );
  },
});

export const initMergeTagsDropdown = (continer: Element, opts: MergeTagsDropdownProps): void => {
  window.PMW.initMergeTagsDropDown(continer, opts);
};

export const renderColorPickerDropdownForText = (contentContainer: HTMLElement, opts: EmailMakerColorPickerDropdownProps): void => {
  window.PMW.renderColorPickerDropdownForText(contentContainer, opts);
};

export const renderMergeTagsComponent = (container: Element, opts: MergeTagsProps): void => {
  window.PMW.initMergeTagsStyles(container, opts);
};

export const initSocialLinksSuggestionsDropdown = (contentContainer: HTMLElement, opts: EmailMakerSocialLinkInputSuggestionsProps): void => {
  window.PMW.initSocialLinksSuggestionsDropdown(contentContainer, opts);
};

export const renderAiRewritePromptBoxDropdown = (contentContainer: HTMLElement, opts: EmailMakerAiRewritePromptBoxDropdownProps): void => {
  renderElement(
    contentContainer,
    <Provider store={window.PMW.redux.store}>
      <EmailMakerAiRewritePromptBoxDropdown {...opts} />
    </Provider>
  );
};

export const TOOLBAR_MERGE_TAGS_LIST_ID = 'toolbar-merge-tags-list';
export const RTE_MERGE_TAGS_LIST_ID = 'rte-merge-tags-list';
export const SIDEBAR_MERGE_TAGS_LIST_ID = 'sidebar-merge-tags-list';
